import * as React from 'react';
import {TicketType} from '../../models/ticketType';
import {History} from 'history';
import {bind} from '../../decorators/bind';
import {Server} from '../../services/server';
import {lazyInject} from '../../services/container';
import classNames from 'classnames';
import {Translate} from '../../services/translate';
import tickIcon from '../../assets/images/tick_icon.svg';
import timesIcon from '../../assets/images/times_icon.svg';
import arrowIcon from '../../assets/images/icon_navbar_arrow_back.png';

interface TicketTypeEntryProps
{
    ticketType: TicketType;
    history: History;
    onClick: (ticketType: TicketType) => void;
}

export class TicketTypeEntry extends React.Component<TicketTypeEntryProps>
{
    @lazyInject(Server)
    private server: Server;
    
    @lazyInject(Translate)
    private translate: Translate;
    
    public render(): React.ReactNode
    {
        const ticketType: TicketType = this.props.ticketType;
        
        return <div className={classNames('ticket-entry ticket-type-entry', {
            'ticket-type-entry-disabled': ticketType.isFull || ticketType.alreadySignedUp,
            'ticket-type-entry-closed': ticketType.isFull,
            'ticket-type-entry-open': !ticketType.isFull
        })} onClick={this.onClick}>
            <div>
                <div>
                    <div className="ticket-type-name">{ticketType.name[this.translate.getLanguage()]}</div>
                    <div className="ticket-type-status">
                        {ticketType.isFull
                            ? this.translate.translate('ticketTypeFull')
                            : ticketType.alreadySignedUp
                                ? this.translate.translate('ticketTypeAlreadyBooked')
                                : this.translate.translate('ticketTypeBookable')}
                    </div>
                </div>
                <div className="ticket-type-price">
                    {this.translate.translate('price', { price: ticketType.seatPrice })}
                </div>
            </div>
            <div>
                <div className="ticket-type-status-symbol">
                    <img src={ticketType.isFull ? timesIcon : tickIcon} alt=""/>
                </div>
                <div className="ticket-large-text ticket-signup-text">
                    {ticketType.isFull
                        ? <span>{this.translate.translate('ticketTypeFull2')}</span>
                        : ticketType.alreadySignedUp
                            ? <span>{this.translate.translate('booked')}</span>
                            : <span>{this.translate.translate('booking')}
                                <img className="right-arrow-icon" src={arrowIcon} alt=""/>
                              </span>
                    }
                </div>
            </div>
        </div>;
    }

    @bind
    private onClick(): void
    {
        if (this.props.ticketType.isFull || this.props.ticketType.alreadySignedUp)
            return;
        
        this.props.onClick(this.props.ticketType);
    }
}